<template>
  <div class="container-fluid mt-4 pb-5">
    
    <!-- 1. OTSIKKO JA VALITSIN -->
    <div class="card mb-4 shadow-sm">
      <div class="card-body d-flex justify-content-between align-items-center flex-wrap">
        <h4 class="h4-responsive font-weight-bold mb-0">
          <i class="fas fa-chart-pie mr-2 text-primary"></i>Tilausanalytiikka
        </h4>
        
        <div class="d-flex align-items-center mt-2 mt-md-0">
          <span class="mr-3 text-muted font-small">Tuotesuodatus:</span>
          <select v-model="selectedId" class="browser-default custom-select" style="width: 280px; border-radius: 5px;">
            <option v-for="s in stats" :key="s.product_id" :value="s.product_id">
              {{ s.product_id }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- LATAUSILMOITUS -->
    <div v-if="loading" class="text-center p-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2 text-muted">Haetaan analytiikkaa...</p>
    </div>

    <!-- PÄÄNÄKYMÄ -->
    <div v-else-if="current">
      
      <!-- 2. KPI-KORTIT (Pääluvut) -->
      <div class="row">
        <!-- Konversio -->
        <div class="col-xl-3 col-md-6 mb-4">
          <div class="card border-left border-primary shadow-sm h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">Konversio</div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">{{ current.conversion_rate }}%</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-percentage fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Liikevaihto (Revenue) -->
        <div class="col-xl-3 col-md-6 mb-4">
          <div class="card border-left border-success shadow-sm h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Laskutettu (Yht)</div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">{{ current.revenue_est }} €</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-euro-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- MRR -->
        <div class="col-xl-3 col-md-6 mb-4">
          <div class="card border-left border-info shadow-sm h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-info text-uppercase mb-1">Toistuva liikevaihto (Kuukausiarvo)</div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">{{ current.mrr_est }} €</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-calendar-check fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Trialissa olevat -->
        <div class="col-xl-3 col-md-6 mb-4">
          <div class="card border-left border-warning shadow-sm h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                  <div class="text-xs font-weight-bold text-warning text-uppercase mb-1">Kokeilujakso kesken</div>
                  <div class="h5 mb-0 font-weight-bold text-gray-800">{{ current.still_in_trial }} kpl</div>
                </div>
                <div class="col-auto">
                  <i class="fas fa-hourglass-start fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. VERTAILUTAULUKKO (Kaikki tuotteet) -->
      <div v-if="selectedId === 'Kaikki tuotteet yhteensä'" class="row mt-2">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header white-text indigo py-3">
              <h6 class="m-0 font-weight-bold">Tuotekohtainen vertailu</h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead class="grey lighten-4">
                    <tr>
                      <th>Nimi</th>
                      <th>Tuote</th>
                      <th>Hinta</th>
                      <th>Käyttäjät</th>
                      <th>Maksavat</th>
                      <th>Liikevaihto (kk)</th>
                      <th>Konversio</th>
                      <th class="text-right">Toiminto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="p in productOnlyList" :key="p.product_id">
                      <td class="font-weight-bold">{{ p.title }}</td>
                      <td>
                        <div class="font-weight-bold">{{ p.product_id }}</div>
                        <small class="text-muted">Laskutusväli: {{ p.billing_label }}</small>
                      </td>
                      <td><span class="badge badge-pill badge-light border">{{ p.price_label }}</span></td>
                      <td>{{ p.total_users }}</td>
                      <td class="text-success font-weight-bold">{{ p.converted_paid }}</td>
                      <td class="font-weight-bold text-primary">{{ p.mrr_est }} €</td>
                      <td>
                        <div class="d-flex align-items-center">
                          <span class="mr-2">{{ p.conversion_rate }}%</span>
                          <div class="progress flex-grow-1" style="height: 5px; min-width: 50px;">
                            <div class="progress-bar bg-primary" :style="{width: p.conversion_rate + '%'}"></div>
                          </div>
                        </div>
                      </td>
                      <td class="text-right">
                        <button @click="selectedId = p.product_id" class="btn btn-outline-indigo btn-sm px-3 m-0 waves-effect">
                          Tiedot
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. TUOTEKOHTAINEN YKSITYISKOHTA -->
      <div v-else class="row mt-2">
        <div class="col-lg-7">
          <div class="card shadow-sm mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">Tiedot: {{ current.product_id }}</h6>
            </div>
            <div class="card-body">
               <div class="row text-center">
                  <div class="col-sm-4 border-right">
                    <p class="text-muted small text-uppercase">Aktiiviset (Yht)</p>
                    <h3 class="font-weight-bold">{{ current.active_now }}</h3>
                  </div>
                  <div class="col-sm-4 border-right">
                    <p class="text-muted small text-uppercase">Trialin pituus</p>
                    <h3 class="font-weight-bold">{{ current.freetrial }} kk</h3>
                  </div>
                  <div class="col-sm-4">
                    <p class="text-muted small text-uppercase">Laskutusväli</p>
                    <h3 class="font-weight-bold">{{ current.billing_period }} kk</h3>
                  </div>
               </div>
               <hr>
               <p class="text-muted">
                 Tämä tuote on tuottanut keskimäärin <strong>{{ (current.revenue_est / (current.converted_paid || 1)).toFixed(2) }} €</strong> per maksava asiakas.
               </p>
            </div>
          </div>
        </div>
        
        <div class="col-lg-5">
          <div class="card shadow-sm mb-4">
            <div class="card-body">
              <h6 class="font-weight-bold mb-3">Käyttäjäjakauma</h6>
              <div class="d-flex justify-content-between mb-1">
                <small>Maksavat ({{ current.converted_paid }})</small>
                <small>Trial ({{ current.still_in_trial }})</small>
              </div>
              <div class="progress mb-4" style="height: 20px;">
                <div class="progress-bar bg-success" :style="{width: (current.converted_paid/current.total_users*100) + '%'}"></div>
                <div class="progress-bar bg-warning" :style="{width: (current.still_in_trial/current.total_users*100) + '%'}"></div>
              </div>
              
              <ul class="list-group list-group-flush">
                <li class="list-group-item px-0 d-flex justify-content-between">
                  Aloitukset yhteensä <span>{{ current.total_users }}</span>
                </li>
                <li class="list-group-item px-0 text-center">
                   <button @click="selectedId = 'Kaikki tuotteet yhteensä'" class="btn btn-link btn-sm">Palaa listaukseen</button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PurchaseStats',
  data() {
    return {
      loading: true,
      stats: [],
      selectedId: 'Kaikki tuotteet yhteensä'
    };
  },
  computed: {
    // Palauttaa valitun tuotteen objektin
    current() {
      return this.stats.find(s => s.product_id === this.selectedId) || null;
    },
    // Palauttaa listan tuotteista ilman yhteenveto-riviä taulukkoa varten
    productOnlyList() {
      return this.stats.filter(s => s.product_id !== 'Kaikki tuotteet yhteensä');
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      // Käytetään antamaasi polkua
      axios.get('/1.0/front/purchasedata/stats')
        .then(response => {
          this.stats = response.data;
        })
        .catch(error => {
          console.error("Virhe ladattaessa tilastoja:", error);
          // Voit lisätä tähän toast-viestin tai virheilmoituksen
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
/* Lisätään hieman hienosäätöä MDB 4:n päälle */
.card {
  border-radius: 0.5rem;
  border: none;
}
.shadow-sm {
  box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
}
.border-left-primary {
  border-left: .25rem solid #4e73df!important;
}
.text-xs {
  font-size: .7rem;
}
.indigo {
  background-color: #3f51b5 !important;
}
.custom-select {
  background-color: #f8f9fa;
}
.font-small {
  font-size: 0.85rem;
}
</style>